module.exports = __webpack_public_path__ + "static/media/blog1_3.6227dd3f.webp";